import { StyledSelect } from '../utils/Styled/select';
import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '../utils/Styled/buttons';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import Style from './style.scss';
import styled from 'styled-components';
import Highlighter from 'react-highlight-words';

export const StyledRow = styled(Row)`
  border-bottom-color: ${props => props.theme.borderColor};
`;

class CategoryFilterItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.clear = this.clear.bind(this);
  }

  handleSelectChange(value) {
    let res = [];
    if (value && value.id) {
      res.push(value);
    }
    res.caption = this.props.label;
    this.props.onChange(this.props.id, res);
  }

  clear() {
    this.handleSelectChange([]);
  }
  renderOption(option) {
    return (
      <Highlighter
        searchWords={[this._inputValue]}
        textToHighlight={option.caption}
        highlightStyle={{ fontWeight: 'bold', backgroundColor: 'transparent' }}
      />
    );
  }

  render() {
    const topClassName = this.props.isTop ? 'menu-outer-top' : '';
    return (
      <StyledRow className={Style.filterRow}>
        <Col className={Style.col1}>
          <ControlLabel
            className={Style.filterLabel}
            title={this.props.label}
            htmlFor={this.props.id}
          >
            {this.props.label}
          </ControlLabel>
        </Col>
        <Col className={Style.col3}>
          <LinkButton
            bsStyle="link"
            disabled={!this.props.value || this.props.value.length === 0}
            onClick={this.clear}
          >
            {this.props.intlObject['ssp.scoreboard.clear']}
          </LinkButton>
        </Col>
        <Col className={Style.col2}>
          <StyledSelect
            className={'singleSelect ' + topClassName}
            id={this.props.id}
            onChange={this.handleSelectChange}
            labelKey="caption"
            valueKey="id"
            options={this.props.options}
            placeholder={this.props.intlObject['ssp.scoreboard.search']}
            value={this.props.value ? this.props.value[0] : null}
            optionRenderer={this.renderOption.bind(this)}
            onInputChange={inputValue => (this._inputValue = inputValue)}
          />
        </Col>
      </StyledRow>
    );
  }
}

CategoryFilterItem.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array,
  value: PropTypes.array,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  asyncOption: PropTypes.func,
  intlObject: PropTypes.object.isRequired,
  isTop: PropTypes.bool
};

export default CategoryFilterItem;



// WEBPACK FOOTER //
// ./components/Scoreboard/categoryFilterItem.js